// src/MainMenu.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExpandableNavItem from "components/ExpandableNavItem";
import NavItem from "components/NavItem";
import FlaticonIcon from "components/FlaticonIcon";

export default function MainMenu({ menuLayout, closeMenuHandler }) {
  const location = useLocation();

  useEffect(() => {
    closeMenuHandler && closeMenuHandler();
  }, [location, closeMenuHandler]);

  return (
    <>
      {/* Group 1: Cross-app links */}
      <ExpandableNavItem
        text={menuLayout.MenuItemGroup1}
        icon={<FlaticonIcon icon="briefcase-blank" ext="svg" />}
        isOpen={true}
      >
        <li className="nav-item">
          <a
            className="nav-link"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/spp"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="briefcase" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem18}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/sp"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="portfolio" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem17}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/mtp"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="government-budget" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem15}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/investmentStreams"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="smart-contract" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem16}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/expertEvaluation"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="assessment" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem19}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/pipDetails"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="description-alt" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem20}</p>
          </a>
        </li>

        <li className="nav-item">
          <a
            className="nav-link nav-item-icon-resize"
            href={process.env.REACT_APP_CROSSAPP_LINK + "/#/programDetails"}
            target="_self"
            rel="noreferrer"
          >
            <span className="nav-icon">
              <FlaticonIcon icon="album-collection" ext="svg" />
            </span>
            <p>{menuLayout.MenuItem21}</p>
          </a>
        </li>
      </ExpandableNavItem>

      {/* Group 2: In-app routes (React) */}
      <ExpandableNavItem
        text={menuLayout.MenuItemGroup2}
        icon={<FlaticonIcon icon="master-plan" ext="svg" />}
        isOpen={true}
      >
        <NavItem
          to="/finPrograms"
          text={menuLayout.MenuItem11}
          icon={<FontAwesomeIcon icon="table-list" />}
        />
        <NavItem
          to="/finProgramsDetails"
          text={menuLayout.MenuItem9}
          icon={<FontAwesomeIcon icon="list-ol" />}
        />
        <NavItem
          to="/applications"
          text={menuLayout.MenuItem10}
          icon={<FontAwesomeIcon icon="scroll" />}
        />
        <NavItem
          to="/"
          text={menuLayout.MenuItem1}
          icon={<FontAwesomeIcon icon="home" />}
        />
        <NavItem
          to="/projects"
          text={menuLayout.MenuItem2}
          icon={<FontAwesomeIcon icon="layer-group" />}
        />
        <NavItem
          to="/projectDetails"
          text={menuLayout.MenuItem3}
          icon={<FontAwesomeIcon icon="list" />}
        />
        <NavItem
          to="/dataAvailability"
          text={menuLayout.MenuItem6}
          icon={<FontAwesomeIcon icon="database" />}
        />
        <NavItem
          to="/financing"
          text={menuLayout.MenuItem4}
          icon={<FontAwesomeIcon icon="hand-holding-dollar" />}
        />
        <NavItem
          to="/financingDetails"
          text={menuLayout.MenuItem5}
          icon={<FontAwesomeIcon icon="receipt" />}
        />
        <NavItem
          to="/budget"
          text={menuLayout.MenuItem7}
          icon={<FontAwesomeIcon icon="sack-dollar" />}
        />
        <NavItem
          to="/contractingProcesses"
          text={menuLayout.MenuItem14}
          icon={<FlaticonIcon icon="handshake-deal-loan" ext="svg" />}
        />
        <NavItem
          to="/investmentProjects"
          text={menuLayout.MenuItem12}
          icon={<FontAwesomeIcon icon="money-bills" />}
        />
        <NavItem
          to="/investmentProjectsLocations"
          text={menuLayout.MenuItem13}
          icon={<FontAwesomeIcon icon="map-location-dot" />}
        />

      </ExpandableNavItem>

    </>
  );
}
